import { render, staticRenderFns } from "./agentDeposit.vue?vue&type=template&id=2452550a&scoped=true&"
import script from "./agentDeposit.vue?vue&type=script&lang=js&"
export * from "./agentDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2452550a",
  null
  
)

export default component.exports